/**
 * 計算提示詞的字數（中文字符 + 英文字母 + 符號）
 * @param text - 要計算的文本
 * @returns 總字數
 */
export const countPromptWords = (text: string): number => {
    const cleanText = text.trim().replace(/\s+/g, " ");
    // 分別計算中文字符、英文字母和符號
    const chineseChars = (cleanText.match(/[\u4e00-\u9fff]/g) || []).length;
    const englishChars = (cleanText.match(/[a-zA-Z]/g) || []).length;
    const symbols = (cleanText.match(/[^\u4e00-\u9fff\sa-zA-Z]/g) || []).length;

    return chineseChars + englishChars + symbols;
};
